import React from 'react';
import { SvgIconProps } from '@mui/material';

export const BackIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="33"
        height="25"
        viewBox="0 0 33 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M32 12.5L1 12.5L12.625 24M6.8125 6.75L12.625 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default BackIcon;
